module.exports = __webpack_public_path__ + "static/media/opportunityIcon.630b5f9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/opportunityIcon.png
// module id = 1490
// module chunks = 0